// interiorQuotationStore.js - version helpers + one-time legacy localStorage cleanup.
// Drafts and sent quotations are stored on Stage via interiorQuotationApi (JSON snapshots).

const STORAGE_KEY = 'innoworx.interiorQuotations.v1';

/** Drop the old localStorage prototype so it cannot reappear beside API drafts. */
export const clearLegacyLocalQuotations = () => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};

export const formatQuotationVersion = (record) => {
  if (record?.version) {
    const v = String(record.version);
    return v.startsWith('v') ? v : `v${v}`;
  }
  return `v${record?.majorVersion ?? 1}.${record?.minorVersion ?? 0}`;
};
